import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PasswordForm } from "../components/auth/PasswordForm.js";
import { adminLogin } from "../api/admin.js";
import { ApiClientError } from "../api/client.js";

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(password: string) {
    setSubmitting(true);
    setError(null);
    try {
      await adminLogin(password);
      navigate("/admin");
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : "Une erreur est survenue");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PasswordForm title="Administration" onSubmit={handleSubmit} submitting={submitting} error={error} />
  );
}
